import { Pipe, PipeTransform, inject } from '@angular/core'
import { Maybe, ProductServiceMeasure } from '@generated/sammathnaur.graphql'
import { TranslateService } from '@ngx-translate/core'
import { constantCase } from 'change-case'

@Pipe({
    name: 'translateProductMeasure',
    standalone: false
})
export class TranslateProductMeasurePipe implements PipeTransform {
  private readonly translateService = inject(TranslateService)

  public transform(productMeasure?: Maybe<ProductServiceMeasure>): string {
    return this.translateService.instant(`TRANSLATE_PRODUCT_MEASURE.${constantCase(productMeasure || ProductServiceMeasure.Units)}`)
  }
}
